import React, { useRef, useState } from 'react';
import { getLabel } from '../../InitData';
import { useLayout } from '../../UISettingsProvider';
import BetsOddsHeader from '../../common/BetsOddsHeader';
import { usePrematchData } from '../PrematchDataFetcher';
import PrematchTournamentMatch from '../prematch-home/PrematchTournamentMatch';
import { classIf, filterBetsByNumberOfOdds, filtraParametriche, handleMouseOverTooltip, hideTooltip, iconSportCssClass } from '../../data/utils';
import IconsScroller from '../../common/IconsScroller';
import { CustomCols } from '../../live/Live';
import { MAX_COLUMNS } from '../../data/constants';
import PrematchContext from '../../contexts/PrematchContext';
import { ReactComponent as CloseIcon } from '../../icons/menu.svg';

function TournamentDesc(props) {
    const prematchData = usePrematchData();
    const [toggled, setToggled] = useState(props.toggled);
    
    function handleToggle() {
        setToggled(!toggled);
    }
    
    const match = props.match;
    const sport = prematchData.sportById[match.sportRef];
    const country = sport.categoryById[match.categoryRef];
    const tournament = country.tournamentById[match.tournamentRef];

    const desc = `${sport.descrizione} | ${country.descrizione} | ${tournament.descrizione} | ${match.date}`;

    return (
        <div className="nome-competizione-sport" onClick={handleToggle}>
            <div className={`img-fluid ico-cat ${country.categoryIcon}`}></div>
            <span className="margine-sx grassetto">{desc}</span>
        </div>
    );
}

function Collapse(props) {
    return (
        <>
            <div className={"titolo-competizione-live bg-grigio-scuro pointer bianco bordo-tondo margine-giu-mezzo toggle-nascondi-live" + classIf(!props.toggled, 'collapsed')} data-toggle="collapse" data-target={`#search-results-collapse-${props.id}`}>
                <span>{props.desc}</span>
            </div>
            <div id={`search-results-collapse-${props.id}`} className={"competzioni-sub collapse in margine-su-mezzo" + classIf(props.toggled, 'show')} role="tabpanel" aria-labelledby={`search-results-collapse-${props.id}`}>
                {props.children}
            </div>
        </>
    );
}

export default function EventSearch(props) {
    const prematchContext = React.useContext(PrematchContext);
    const layout = useLayout();
    const prematchData = usePrematchData();
    const customCols = React.useContext(CustomCols);
    const data = props.data;
    const [selectedSport, setSelectedSport] = useState(data.sports[0]);
    const iconsContainer = useRef(null);

    const sportButtons = data.sports.map(sport => {
        const selected = sport === selectedSport;
        const sportData = prematchData.sportById[sport.id];
        return (
            <div key={sportData.id} className={"icona-slider-sport" + classIf(selected, 'icona-selezionata')} onClick={() => setSelectedSport(sport)}>
                <figure className="sport-icona-live">
                    <span className="contatore-live-icone">{sport.matches.length}</span>
                    <div className={`img-fluid ico-sport ${iconSportCssClass(sportData.id, null)}`}></div>
                    <span>{sportData.descrizione}</span>
                </figure>
            </div>
        );
    });
    
    return (
        <CustomCols.Provider value={MAX_COLUMNS}>
            <div className={"griglia-centrale-sport col stringimento-sidebar " + layout.order.divCentrale} id="div-centrale">
                <div className="contenitore-schedine-sport">
                    <div className="competizione-interna unaColonna">
                        <div id="primo-blocco-sport" className="sport-blocco primo-blocco-sport go-up-arrow-on-overflow no-margin tablesExpanded">
                            <div className="container-slider-icone mb-2 overflow-unset has-icons-container-no-wrap">
                                <div className="icons-slider-container">
                                    <div className="slider-icone-sport horiz-sc icons-container icons-container-no-wrap" ref={iconsContainer}>
                                        {sportButtons}
                                    </div>
                                    <IconsScroller buttons={sportButtons} iconsContainer={iconsContainer.current} />
                                </div>
                                <div className="d-flex flex-grow-1 justify-content-center align-items-center">
                                    <CloseIcon
                                        className="pointer"
                                        onClick={() => prematchContext.reset()}
                                        onMouseOver={handleMouseOverTooltip}
                                        onMouseOut={hideTooltip}
                                        data-desc={getLabel('prematch_page.control_icon.close_all')}
                                    />
                                </div>
                            </div>
                            <div className="titolo-blocco-sport bg-nero bianco pointer">
                                <div className="nome-competizione-sport">
                                    <h1 className="grassetto">{getLabel('general.results_for')} "{props.search}"</h1>
                                </div>
                            </div>
                            <div className="competizione-sport" id="competizione-1">
                                <div className="blocco-quote-espanse">
                                    <div className="contenitore-table bg-bianco collapse show bordo-tondo" id="tabella-c">
                                        <div className="contenitore-table bg-bianco collapse show bordo-tondo">
                                            {selectedSport.matches.map((match, i) => {
                                                const baseId = `${selectedSport.id}_${i}`;
                                                const singleResult = selectedSport.matches.length === 1;
                                                return (
                                                    <Collapse key={baseId} id={baseId} desc={match.id} toggled={singleResult}>
                                                        {match.tournaments.map(t =>
                                                            t.dates.map(date => {
                                                                const events = t.dateById.get(date);
                                                                const firstMatch = events[0];
                                                                let bets = firstMatch.bets;
                                                                bets = filtraParametriche(bets);
                                                                bets = filterBetsByNumberOfOdds(bets, customCols);
    
                                                                function handleClick() {
                                                                    const tournamentUniqueId = `${firstMatch.sportRef}_${firstMatch.categoryRef}_${firstMatch.tournamentRef}`;
                                                                    prematchContext.openEvent(tournamentUniqueId, firstMatch)
                                                                }
    
                                                                return (
                                                                    <>
                                                                        <div className="tabellaQuoteIntestazione text_s1 tabellaQuoteIntestazionePrematch tabellaQuotePrematch_5col">
                                                                            <div className="tabellaQuoteAlias d-flex justify-content-center align-items-center">{getLabel('prematch_page.torneo.tournament_day_header.alias')}</div>
                                                                            <div className="tabellaQuoteTempo d-flex justify-content-center align-items-center">
                                                                                <p>{getLabel('prematch_page.torneo.tournament_day_header.time')}</p>
                                                                            </div>
                                                                            <div className="tabellaQuoteSquadre">
                                                                                <TournamentDesc match={firstMatch} />
                                                                            </div>
                                                                            <div className="tabellaQuoteContenitoreQuotazioni d-flex justify-content-end align-items-center flex-grow-1">
                                                                                <BetsOddsHeader bets={bets} matches={[firstMatch]} />
                                                                            </div>
                                                                            <div className="tabellaQuoteStatistiche"></div>
                                                                            <div className="tabellaQuoteAltre"></div>
                                                                        </div>
                                                                        {events.map(e =>
                                                                            <>
                                                                                <PrematchTournamentMatch key={e.id}
                                                                                                        match={e}
                                                                                                        isLive={false}
                                                                                                        isLastMinute={false}
                                                                                                        openMatch={handleClick}
                                                                                />
                                                                            </>
                                                                        )}
                                                                    </>
                                                                );
                                                            })
                                                        )}
                                                    </Collapse>
                                                );
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CustomCols.Provider>
    );
}
